<!-- //
模型列表
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refForm" :model="queryParams" size="small" :inline="true" label-width="100px">
        <el-form-item prop="modelName">
          <el-input
              v-model="queryParams.modelName"
              placeholder="请输入模型名称"
              style="width: 300px;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新建模型</el-button>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: calc(100% - 63px);">
      <el-table ref="refTable" v-loading="tableLoading" :data="list"
                border
                stripe
                height="600"
                size="small"
                :header-cell-style="this.tableHeader">
        <el-table-column header-align="center" align="center" label="No." width="60" type="index"/>
        <el-table-column header-align="left" align="left" label="模型名称" min-width="120" prop="modelName"/>
        <el-table-column header-align="left" align="left" label="数据库类型" width="100" prop="dbType"/>
        <el-table-column header-align="left" align="left" label="地址" min-width="100" prop="hostName"/>
        <el-table-column header-align="left" align="left" label="端口" width="60" prop="port"/>
        <el-table-column header-align="left" align="left" label="连接参数" min-width="250" prop="properties"/>
        <el-table-column header-align="left" align="left" label="数据库名" width="110" prop="dbName"/>
        <el-table-column header-align="left" align="left" label="账号" width="90" prop="username"/>
        <el-table-column header-align="left" align="left" label="密码" width="100" prop="pwd"/>
        <el-table-column header-align="left" align="left" label="" width="120" prop="maxWaitTime">
          <template #header>
            <span>连接等待时间(S)</span>
          </template>
        </el-table-column>
        <el-table-column header-align="left" align="left" label="最大连接数" width="90" prop="maxActive"/>
        <el-table-column header-align="left" align="left" label="查询超时(S)" width="90" prop="queryTimeout"/>
        <el-table-column header-align="left" align="left" label="有效状态" width="70" prop="status">
          <template slot-scope="{row}">
            <dict-tag :options="{type: 'tag'}" dictType="YES_OR_NO" :value="row.status"/>
          </template>
        </el-table-column>
        <el-table-column header-align="left" label="操作" align="left" width="140" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleTest(row)" :loading="row.loading">测试</el-button>
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import ModelApi from '@/api/datasvc/model.api.js';
import AddDlg from './add';

export default {
  name: 'ViewModelList',
  components: {AddDlg},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'DB_TYPE', dataType: String},
  ],
  data() {
    return {
      list: [],
      total: 0,
      tableLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        modelName: null,
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      ModelApi.searchList(this.queryParams).then(resp => {
        this.list = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm('refForm');
      this.handleQuery();
    },

    /**
     * 新增
     */
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        data: {},
        mode: 1,
        title: '添加数据源',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleEdit(row) {
      this.$refs.refAddDlg.showModal({
        data: {...row},
        mode: 2,
        title: '编辑数据源',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.modelName}】吗？`).then(() => {
        ModelApi.deleteInfo(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },

    /**
     * 测试
     * @param row
     */
    handleTest(row) {
      row.loading = true;
      ModelApi.testConn(row.id).then(resp => {
        row.loading = false;
        if (resp.data) {
          this.$modal.msgSuccess('连接成功');
        } else {
          this.$modal.msgError('连接失败');
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

.button {
  cursor: pointer;
  margin: 0 10px;
  font-size: 12px;
}
</style>
